import { useTranslation } from "react-i18next";
import UploadBase64 from "../../../components/Files/FileBase64";
import IconClear from "../../../layout/others/icon_clear.svg";
export function Files({ precandidate, setPrecandidate, onSetResult }) {
  const { t } = useTranslation();
  function setUploadResult(fileBase64) {
    if (onSetResult) onSetResult(fileBase64);
    else {
      let _precandidate = { ...precandidate };

      if (_precandidate.fileBase64) {
        _precandidate.fileBase64 = _precandidate.fileBase64.concat(fileBase64);
      } else {
        _precandidate.fileBase64 = fileBase64;
      }

      setPrecandidate(_precandidate);
    }
  }
  function deleteFile(id) {
    let _precandidate = { ...precandidate };
    if (_precandidate.DeletedfileBase64)
      _precandidate.DeletedfileBase64.push(id);
    else {
      _precandidate.DeletedfileBase64 = [];
      _precandidate.DeletedfileBase64.push(id);
    }
    let fileIndex = _precandidate.files.map((file) => file.id).indexOf(id);
    _precandidate.files.splice(fileIndex, 1);
    setPrecandidate(_precandidate);
  }
  function deleteAddedFile(filename) {
    let _precandidate = { ...precandidate };
    let index = _precandidate.fileBase64
      .map((x) => x.fileName)
      .indexOf(filename);
    _precandidate.fileBase64.splice(index, 1);
    setPrecandidate(_precandidate);
  }

  return (
    <div className="row">
      <div className="col-md">
        <div className="col-md">
          <UploadBase64
            multiple={false}
            accept="application/pdf, application/msword, text/xml, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            afterLoadCallback={setUploadResult}
          />
        </div>
        <div className="row align-items-center">
          {precandidate?.files &&
            precandidate?.files.map((file) => (
              <>
                <div className="col-3 text-truncate" key={file.id}>
                  <label title={file.filename}>{file.filename}</label>
                </div>
                <div className="col">
                  <button
                    title={t("Delete file")}
                    type="button"
                    className="action-button"
                    onClick={() => deleteFile(file.id)}
                  >
                    <img src={IconClear} alt="delete" />
                  </button>
                </div>
              </>
            ))}
          {precandidate?.fileBase64 &&
            precandidate?.fileBase64.map((file, index) => (
              <>
                <div className="col-3 text-truncate " key={index}>
                  <label title={file.fileName}>{file.fileName}</label>
                </div>
                <div className="col">
                  <button
                    title={t("Delete file")}
                    type="button"
                    className="action-button"
                    onClick={() => deleteAddedFile(file.fileName)}
                  >
                    <img src={IconClear} alt="delete" />
                  </button>
                </div>
              </>
            ))}
        </div>
      </div>
    </div>
  );
}
